import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { maskMap } from '@defi/core-utils';
class InputMasked extends Component {
  constructor(props) {
    super(props);
    this.handleChange = e => {
      let curPos = e.target.selectionEnd;
      var normalizedValue = this.normalize(e.target.value);

      // for when extra character is added like , in Money curPos needs to be moved up
      if (normalizedValue.length > e.target.value.length) {
        curPos += normalizedValue.length - e.target.value.length;
      }
      this.setState({
        currentValue: normalizedValue
      });
      e.preventDefault();
      this.setState({
        curPos
      }, () => {
        this.props.onChange(normalizedValue);
      });
    };
    this.normalize = value => {
      if (this.props.mask.hasMask) {
        if (this.props.mask.editMask) {
          return maskMap.getMaskedValue(value, this.props.mask.editMask, true);
        } else {
          return maskMap.getMaskedValue(value, this.props.mask.readEditMask, true);
        }
      } else {
        return value;
      }
    };
    this.state = {
      isFocused: false,
      currentValue: props.value,
      curPos: (props.value || '').length
    };
  }
  componentDidUpdate() {
    if (this.refs.textField) {
      this.refs.textField.input.setSelectionRange(this.state.curPos, this.state.curPos);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(TextField, Object.assign({}, this.props, {
      context: "",
      onChange: this.handleChange,
      value: this.state.currentValue,
      multiline: this.props.multiLine ? true : false,
      InputProps: {
        inputProps: {
          maxLength: this.props.maxLength
        }
      },
      "data-testid": "InputMasked"
    }));
  }
}
export default InputMasked;